import WatchSE3Image1 from '../../../assets/apple/iWatch/WatchSE3/WatchSE3_1.png';
import WatchSE3Image4 from '../../../assets/apple/iWatch/WatchSE3/WatchSE3_4.png';
// //
import Series10AluminiumCase from '../../../assets/apple/iWatch/Series10(AluminiumCase).jpeg';
import Series10JetBlackAluminium from '../../../assets/apple/iWatch/Series10JetBlackAluminium.jpeg';
import Series10SilverAluminium from '../../../assets/apple/iWatch/Series10SilverAluminium.jpeg';
import Series10RoseGoldAluminium from '../../../assets/apple/iWatch/Series10RoseGoldAluminium.jpeg';
import Series10last from '../../../assets/apple/iWatch/Series10last.jpeg';
import Series10lasttxt from '../../../assets/apple/iWatch/Series10lasttxt.jpeg';
import Series11TitaniumImage1 from '../../../assets/apple/iWatch/WatchSeries11/WatchSeries11/Series11_1.png';
import Series11TitaniumImage2 from '../../../assets/apple/iWatch/WatchSeries11/WatchSeries11/Series11_2.png';
import Series11TitaniumImage3 from '../../../assets/apple/iWatch/WatchSeries11/WatchSeries11/Series11_3.png';
import Series11AluminumImage1 from '../../../assets/apple/iWatch/WatchSeries11/Series11_1.png';
import Series11AluminumImage2 from '../../../assets/apple/iWatch/WatchSeries11/Series11_2.png';
import Series11AluminumImage3 from '../../../assets/apple/iWatch/WatchSeries11/Series11_3.png';
import Series11AluminumImage4 from '../../../assets/apple/iWatch/WatchSeries11/Series11_4.png';
import BestInCatUltra3 from '../../../assets/BestInCate/BestInCatWatch/Watch1.png';
import Ultra3D1 from '../../../assets/apple/iWatch/Ultra3/Ultra3D1.png';

const series11TitaniumImages = [
  Series11TitaniumImage1,
  Series11TitaniumImage2,
  Series11TitaniumImage3,
];

const series11AluminumImages = [
  Series11AluminumImage1,
  Series11AluminumImage2,
  Series11AluminumImage3,
  Series11AluminumImage4,
];

const series11CommonSpecifications = {
  'Display & Design': [
    'Always-On Retina LTPO3 OLED display (wide-angle), up to ~2000 nits brightness.',
    'Available in 42 mm and 46 mm aluminium or titanium cases with multiple finishes.',
    'Durable Ion-X glass (aluminium) or sapphire crystal (titanium), ~2× more scratch resistant than before.',
  ],
  'Performance & OS': [
    'S10 chip with 64-bit dual-core processor.',
    'Runs watchOS 26 with new gestures (for example, wrist flick) and refreshed UI.',
  ],
  Battery: [
    'Up to ~24 hours of typical use.',
    'Up to ~38 hours in Low Power Mode.',
    'Fast charging (15 min gives approximately ~8 hours of use).',
  ],
  'Health & Fitness': [
    'Heart rate monitoring, ECG, blood oxygen and wrist temperature sensing.',
    'Sleep tracking with new Sleep Score.',
    'Hypertension (high blood pressure) alert and tendencies tracking.',
    'Workout app with advanced metrics and activity rings.',
  ],
  'Safety & Connectivity': [
    'Fall Detection, Emergency SOS, and Crash Detection.',
    'GPS only and GPS + Cellular (optional 5G) with improved antenna design.',
    'Bluetooth and Wi-Fi support.',
  ],
  Durability: [
    'Water resistance (50 m) and dust resistance (IP6X).',
    'Thin, comfortable design suitable for day and night wear.',
  ],
};

const createSeries11Specifications = (caseType, dialSize, connectivity) => ({
  Variant: [
    `${caseType} - ${dialSize}.`,
    connectivity,
  ],
  ...series11CommonSpecifications,
});

const watchSE3Images = [
  WatchSE3Image4,
  WatchSE3Image1,
];

const watchSE3CommonSpecifications = {
  'Display & Design': [
    'Always-On Retina LTPO OLED display.',
    '40 mm and 44 mm aluminium case.',
    'Durable Ion-X glass with lightweight body.',
  ],
  Performance: [
    'S10 SiP chip for faster performance.',
    'On-device Siri.',
  ],
  Battery: [
    'Up to 18 hours per charge.',
    'Fast charging with Low Power Mode extending up to ~32 hours.',
  ],
  'Health & Fitness': [
    'Sleep tracking, heart rate, and wrist temperature.',
    'Cycle Tracking and retrospective ovulation estimates.',
    'Fall Detection, Crash Detection, and Emergency SOS.',
    'Workout app, Activity rings, and personalized motivation.',
  ],
  'Connectivity & Durability': [
    'GPS only and GPS + Cellular options.',
    'Bluetooth, Wi-Fi, and seamless iPhone integration.',
    '50 m water resistance.',
  ],
};

const createWatchSE3Specifications = (dialSize, connectivity) => ({
  Variant: [
    `Aluminium case in ${dialSize}.`,
    connectivity,
  ],
  ...watchSE3CommonSpecifications,
});

export const appleWatchProducts = [
  {
    id: 6,
    title: 'Apple Watch Ultra 3',
    productImage: BestInCatUltra3,
    images: [
      BestInCatUltra3,
      Ultra3D1,
    ],
    originalPrice: '1,04,900',
    discountedPrice: '1,02,900',
    colors: ['Natural Titanium', 'Black Titanium'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI from ₹17,150/month' },
    ],
    specifications: {
      'Display & Design': [
        'Largest Apple Watch display ever with LTPO3 wide-angle OLED up to 3000 nits brightness and Always-On support.',
        'Titanium case (Grade 5) in Natural or Black.',
        'Large 49 mm form factor with rugged build.',
      ],
      'Performance & Chip': [
        'S10 chip with 64-bit dual-core processor and 4-core Neural Engine.',
        '64 GB storage for apps and data.',
      ],
      'Battery & Charging': [
        'Up to ~42 hours of typical use.',
        'Up to ~72 hours in Low Power Mode.',
        'Fast charging: ~15 min for up to 12 hours of use.',
      ],
      'Health & Wellness': [
        'Heart rate, ECG, blood oxygen (SpO₂), wrist temperature.',
        'Sleep tracking with sleep score.',
        'Hypertension notifications for potential high blood pressure signs.',
        'Cycle Tracking with retrospective ovulation estimates.',
      ],
      'Safety & Connectivity': [
        'Emergency SOS via satellite with two-way messaging off the grid.',
        '5G cellular support for faster downloads and connectivity.',
        'Fall Detection, Crash Detection, and International Emergency Calling.',
      ],
      'Fitness & Outdoor Features': [
        'Precision dual-frequency GPS and advanced workout metrics.',
        'Action button for quick workout control.',
      ],
      Durability: [
        'Water resistance to 100 m and dive-ready features (depth gauge, water temp sensor).',
        'Siren and robust speakers for outdoor alerts.',
      ],
      Usability: [
        'Gesture controls: double tap and wrist flick.',
        'On-device Siri and Precision Finding for iPhone.',
      ],
    },
  },
  {
    id: 7,
    title: 'Apple Watch Series 11 (Titanium + Milanese Loop, 42mm - GPS + Cellular)',
    productImage: Series11TitaniumImage1,
    images: series11TitaniumImages,
    originalPrice: '84,900',
    discountedPrice: '84,900',
    colors: ['Titanium'],
    offers: [],
    specifications: createSeries11Specifications(
      'Titanium + Milanese Loop',
      '42mm',
      'GPS + Cellular.'
    ),
  },
  {
    id: 8,
    title: 'Apple Watch Series 11 (Titanium + Milanese Loop, 46mm - GPS + Cellular)',
    productImage: Series11TitaniumImage3,
    images: series11TitaniumImages,
    originalPrice: '89,900',
    discountedPrice: '89,900',
    colors: ['Titanium'],
    offers: [],
    specifications: createSeries11Specifications(
      'Titanium + Milanese Loop',
      '46mm',
      'GPS + Cellular.'
    ),
  },
  {
    id: 14,
    title: 'Apple Watch Series 11 (Aluminum Case - 42mm - GPS Only)',
    productImage: Series11AluminumImage1,
    images: series11AluminumImages,
    originalPrice: '46,900',
    discountedPrice: '46,900',
    colors: ['Jet Black', 'Rose Gold', 'Silver'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI Available' },
    ],
    specifications: createSeries11Specifications(
      'Aluminum Case',
      '42mm',
      'GPS only.'
    ),
  },
  {
    id: 15,
    title: 'Apple Watch Series 11 (Aluminum Case - 46mm - GPS Only)',
    productImage: Series11AluminumImage2,
    images: series11AluminumImages,
    originalPrice: '49,900',
    discountedPrice: '49,900',
    colors: ['Jet Black', 'Rose Gold', 'Silver'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI Available' },
    ],
    specifications: createSeries11Specifications(
      'Aluminum Case',
      '46mm',
      'GPS only.'
    ),
  },
  {
    id: 16,
    title: 'Apple Watch Series 11 (Aluminum Case - 42mm - GPS + Cellular)',
    productImage: Series11AluminumImage3,
    images: series11AluminumImages,
    originalPrice: '56,900',
    discountedPrice: '56,900',
    colors: ['Jet Black', 'Rose Gold', 'Silver'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI Available' },
    ],
    specifications: createSeries11Specifications(
      'Aluminum Case',
      '42mm',
      'GPS + Cellular.'
    ),
  },
  {
    id: 17,
    title: 'Apple Watch Series 11 (Aluminum Case - 46mm - GPS + Cellular)',
    productImage: Series11AluminumImage4,
    images: series11AluminumImages,
    originalPrice: '59,900',
    discountedPrice: '59,900',
    colors: ['Jet Black', 'Rose Gold', 'Silver'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI Available' },
    ],
    specifications: createSeries11Specifications(
      'Aluminum Case',
      '46mm',
      'GPS + Cellular.'
    ),
  },
  {
    id: 5,
    title: 'Series 10 (Aluminium Case)',
    productImage: Series10AluminiumCase,
    images: [
      Series10JetBlackAluminium,
      Series10SilverAluminium,
      Series10RoseGoldAluminium,
      Series10last,
      Series10lasttxt,
    ],
    originalPrice: '46,900',
    discountedPrice: '44,400',
    // offerText: 'Flat ₹3,000 off',
    colors: ['Jet Black', 'Rose Gold', 'Silver'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI from ₹7,400/month' },
    ],
    specifications: {
      // Display: 'Always-On Retina LTPO OLED',
      // Memory: '64GB Storage',
      // Camera: 'N/A',
      // Battery: '18 hours, fast charging',
      Specs: [
        '46mm/42mm aluminum case.',
        'LTPO3 OLED Always-on Retina display.',
        'S10 SIP',
        'Up to 18 hours & up to 36 hours in Low Power Mode.',
        'Sleep tracking',
        'Blood Oxygen app',
        'Vitals app featuring heart rate, respiratory rate, wrist temperature, blood oxygen and sleep duration.',
        'Cycle tracking with retrospective ovulation estimates.',
        '50m Water resistant',
        'Available in GPS only and GPS + Cellular',
      ],
    },
  },
  {
    id: 1,
    title: 'Apple Watch SE 3 (40mm - GPS Only)',
    productImage: WatchSE3Image1,
    images: watchSE3Images,
    originalPrice: '25,900',
    discountedPrice: '25,900',
    colors: ['Midnight', 'Starlight', 'Silver'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI Available' },
    ],
    specifications: createWatchSE3Specifications(
      '40mm',
      'GPS only connectivity.'
    ),
  },
  {
    id: 11,
    title: 'Apple Watch SE 3 (44mm - GPS Only)',
    productImage: WatchSE3Image1,
    images: watchSE3Images,
    originalPrice: '28,900',
    discountedPrice: '28,900',
    colors: ['Midnight', 'Starlight', 'Silver'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI Available' },
    ],
    specifications: createWatchSE3Specifications(
      '44mm',
      'GPS only connectivity.'
    ),
  },
  {
    id: 12,
    title: 'Apple Watch SE 3 (40mm - GPS + Cellular)',
    productImage: WatchSE3Image1,
    images: watchSE3Images,
    originalPrice: '30,900',
    discountedPrice: '30,900',
    colors: ['Midnight', 'Starlight', 'Silver'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI Available' },
    ],
    specifications: createWatchSE3Specifications(
      '40mm',
      'GPS + Cellular connectivity.'
    ),
  },
  {
    id: 13,
    title: 'Apple Watch SE 3 (44mm - GPS + Cellular)',
    productImage: WatchSE3Image1,
    images: watchSE3Images,
    originalPrice: '33,900',
    discountedPrice: '33,900',
    colors: ['Midnight', 'Starlight', 'Silver'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI Available' },
    ],
    specifications: createWatchSE3Specifications(
      '44mm',
      'GPS + Cellular connectivity.'
    ),
  },
];
